import React from 'react';
import { useHistory } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';

import styles from './Container.module.css';

interface ITopic {
  title: string;
  paragraphs: string[];
}

interface IProps {
  heading: string;
  children: ITopic[];
}

const Container = ({ heading, children }: IProps) => {
  const history = useHistory();
  const goBack = () => history.goBack();

  return (
    <DashboardCard fullHeight className={styles.container}>
      <NavigationTitle to="#/" onClick={goBack} layoutType={LayoutType.support}>
        {heading}
      </NavigationTitle>
      <section className={styles.listContainer}>
        <List disablePadding>
          {children.map(({ title, paragraphs }) => (
            <ListItem key={title} disableGutters className={styles.listItem}>
              <article>
                <h4 className={styles.listItemTitle}>{title}</h4>
                <div className={styles.listItemBody}>
                  {/* eslint-disable-next-line react/no-array-index-key */}
                  {paragraphs.map((text, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <p key={i}>{text}</p>
                  ))}
                </div>
              </article>
            </ListItem>
          ))}
        </List>
      </section>
    </DashboardCard>
  );
};

export default Container;
